import React, { useState } from 'react';
import reservations from '../CHECK-IN/JSON/Data';

const ReservationTable = ({ emailQuery, lastNameQuery, bookingIdQuery }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const reservationsPerPage = 6;

  // Filter logic
  const filteredReservations = reservations.filter((reservation) => {
    const emailMatches = reservation.email.toLowerCase().includes(emailQuery.toLowerCase());
    const lastNameMatches = reservation.lastName
      .toLowerCase()
      .includes(lastNameQuery.toLowerCase());

    const bookingIdMatches = reservation.bookingId
      .toLowerCase()
      .includes(bookingIdQuery.toLowerCase());

    return (
      (emailQuery === '' || emailMatches) &&
      (lastNameQuery === '' || lastNameMatches) &&
      (bookingIdQuery === '' || bookingIdMatches)
    );
  });

  const indexOfLastReservation = currentPage * reservationsPerPage;
  const indexOfFirstReservation = indexOfLastReservation - reservationsPerPage;
  const currentReservations = filteredReservations.slice(
    indexOfFirstReservation,
    indexOfLastReservation
  );

  const totalPages = Math.ceil(filteredReservations.length / reservationsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-4 py-1 mx-2 ${
            currentPage === i
              ? 'bg-blue-500 text-white rounded-full'
              : 'bg-gray-300 text-black rounded-full'
          } rounded`}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  return (
    <div className="relative p-5 flex flex-col h-full">
      <div className="overflow-x-auto mt-1 flex-grow">
        {/* Table */}
        <table className="table-auto w-full border-collapse border border-gray-300 text-sm ">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2 text-left w-32">Sr. No.</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-36">Booking-ID</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-full">Name</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-40">Room Type</th>
              <th className="border border-gray-300 px-1 py-2 text-left w-48">Check-In</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-48">Check-Out</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-20">No. of Rooms</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-24">Total Guests</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-32">
                Smoking Preference
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left w-32">Email</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-28">Pick-Up</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-28">Location</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-28">Total Amount</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-28">Mobile No.</th>
              <th className="border border-gray-300 px-4 py-2 text-left w-32">Additional Notes</th>
            </tr>
          </thead>
          <tbody>
            {currentReservations.length > 0 ? (
              currentReservations.map((reservation, index) => (
                <tr key={index} className="hover:bg-gray-100 transition">
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {index + 1 + indexOfFirstReservation}
                  </td>
                  <td className="border border-gray-300 px-2 py-2">{reservation.bookingId}</td>
                  <td className="border border-gray-300 px-2 py-2">
                    {reservation.firstName} {reservation.lastName}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.roomType}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.checkInDate}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.checkOutDate}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.numOfRooms}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.totalGuests}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {reservation.smokingPreference}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.email}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.pickUpOption}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.location}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.totalAmount}</td>
                  <td className="border border-gray-300 px-4 py-2">{reservation.mobileNo}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {reservation.additionalNotes}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="text-center py-4">
                  No reservations found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-black text-white rounded"
        >
          Previous
        </button>

        {/* Page Number Buttons */}
        {renderPageNumbers()}

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-black text-white rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ReservationTable;
